import * as React from 'react';

export const PopupStyle: React.CSSProperties & { borderWidth: number } = {
  background: 'white',
  borderColor: `var(--context-menu-border-color, #C9C9C9)`, // elevation/border/on-light/default
  borderRadius: `var(--context-menu-border-radius, 1px)`,
  borderStyle: 'solid',
  borderWidth: 1,
  boxShadow: 'var(--context-menu-box-shadow, 0px 2px 16px 0px rgba(46, 46, 46, 0.15))', // on-light/elevated
  boxSizing: 'border-box',
  lineHeight: 'normal',
};
